import React from 'react'
import Intro from '../../components/intro/intro'
import Contacts from '../../components/contacts/Contacts'
import Footer from '../../components/Footer'
import Proyects from '../../components/proyects/Proyects'
import Services from '../../components/services/services'
import './home.css'

export default function Home(props) {
  return (
    <>
      <Intro />
      <Services />
      <Proyects />
      <Contacts />
      <Footer />
    </>
  )
}